var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "craft-instruction-book" }, [
    _c(
      "div",
      { staticClass: "pdmProcessContentVoTable" },
      [
        _c(
          "el-table",
          {
            attrs: {
              data: _vm.pdmProcessContentVo.cuttingRequirementList,
              "span-method": function (arg) {
                return _vm.arraySpanMethod(arg, "cuttingRequirementList")
              },
              border: "",
            },
          },
          [
            _c(
              "el-table-column",
              { attrs: { label: "类型", width: "90" } },
              [[_c("span", [_vm._v("裁床要求")])]],
              2
            ),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { label: "序号", type: "index", width: "90" },
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { label: "项目", prop: "title", width: "180" },
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { label: "工艺描述", prop: "content" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("span", {
                        domProps: { innerHTML: _vm._s(scope.row.content) },
                      }),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "pdmProcessContentVoTable" },
      [
        _c(
          "el-table",
          {
            attrs: {
              data: _vm.pdmProcessContentVo.sewingRequirementList,
              "span-method": function (arg) {
                return _vm.arraySpanMethod(arg, "sewingRequirementList")
              },
              border: "",
              "show-header": false,
            },
          },
          [
            _c(
              "el-table-column",
              { attrs: { width: "90" } },
              [[_c("span", [_vm._v("车缝要求")])]],
              2
            ),
            _vm._v(" "),
            _c("el-table-column", { attrs: { type: "index", width: "90" } }),
            _vm._v(" "),
            _c("el-table-column", { attrs: { prop: "title", width: "180" } }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { prop: "content" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("span", {
                        domProps: { innerHTML: _vm._s(scope.row.content) },
                      }),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "pdmProcessContentVoTable" },
      [
        _c(
          "el-table",
          {
            attrs: {
              data: _vm.pdmProcessContentVo.tailRequirementList,
              "span-method": function (arg) {
                return _vm.arraySpanMethod(arg, "tailRequirementList")
              },
              border: "",
              "show-header": false,
            },
          },
          [
            _c(
              "el-table-column",
              { attrs: { width: "90" } },
              [[_c("span", [_vm._v("尾部要求")])]],
              2
            ),
            _vm._v(" "),
            _c("el-table-column", { attrs: { type: "index", width: "90" } }),
            _vm._v(" "),
            _c("el-table-column", { attrs: { prop: "title", width: "180" } }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { prop: "content" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("span", {
                        domProps: { innerHTML: _vm._s(scope.row.content) },
                      }),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", [
      _c(
        "div",
        { staticClass: "title", staticStyle: { "text-align": "center" } },
        [
          _c("span", { staticStyle: { float: "left" } }, [_vm._v("包装规格")]),
          _vm._v(" "),
          _c(
            "span",
            _vm._l(
              _vm.pdmProcessContentVo.pdmProcessPackagingList,
              function (item, index) {
                return _c(
                  "el-radio",
                  {
                    key: index,
                    attrs: { value: item.choose, label: true, disabled: "" },
                  },
                  [_vm._v("\n          " + _vm._s(item.name) + "\n        ")]
                )
              }
            ),
            1
          ),
        ]
      ),
    ]),
    _vm._v(" "),
    _c("div", [
      _c(
        "div",
        { staticClass: "title", staticStyle: { "text-align": "center" } },
        [
          _c("span", { staticStyle: { float: "left" } }, [
            _vm._v("客户投诉问题必看"),
          ]),
          _vm._v(" "),
          _c("div", [
            _c(
              "span",
              { staticClass: "mr-12" },
              [
                _c("el-checkbox", { attrs: { disabled: "" } }, [
                  _vm._v("图片不符"),
                ]),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "span",
              { staticClass: "mr-12" },
              [
                _c("el-checkbox", { attrs: { disabled: "" } }, [
                  _vm._v("尺寸问题"),
                ]),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "span",
              { staticClass: "mr-12" },
              [
                _c("el-checkbox", { attrs: { disabled: "" } }, [
                  _vm._v("尺码偏大"),
                ]),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "span",
              { staticClass: "mr-12" },
              [
                _c("el-checkbox", { attrs: { disabled: "" } }, [
                  _vm._v("尺码偏小"),
                ]),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "span",
              { staticClass: "mr-12" },
              [
                _c("el-checkbox", { attrs: { disabled: "" } }, [
                  _vm._v("破损"),
                ]),
              ],
              1
            ),
          ]),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }